export default "__VITE_ASSET__Dx_NB8qe__"